(function ($) {
  $(document).ready(function () {
    console.log("optimized");

    /*
     * PERFORMANCE UTILITIES
     */

    // Throttle function to limit execution rate
    function throttle(func, wait) {
      let timeout;
      let previous = 0;
      return function (...args) {
        const now = Date.now();
        const remaining = wait - (now - previous);
        if (remaining <= 0 || remaining > wait) {
          if (timeout) {
            clearTimeout(timeout);
            timeout = null;
          }
          previous = now;
          func.apply(this, args);
        } else if (!timeout) {
          timeout = setTimeout(() => {
            previous = Date.now();
            timeout = null;
            func.apply(this, args);
          }, remaining);
        }
      };
    }

    // Debounce function to delay execution
    function debounce(func, wait) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    /*
     * Navigation
     */

    // FIXED: Throttled scroll event for header
    const handleHeaderScroll = throttle(function () {
      if ($(window).scrollTop() > 77) {
        $("#header").addClass("scrolled");
      } else {
        $("#header").removeClass("scrolled");
      }
    }, 100);

    $(window).on("scroll", handleHeaderScroll);

    // Reset menu state on page load, even with back navigation
    window.onpageshow = function (event) {
      if (
        event.persisted ||
        performance.getEntriesByType("navigation")[0].type === "back_forward"
      ) {
        $("#main-nav").removeClass("show");
        $(".navbar-toggler").removeClass("open");
      }
    };

    // Navbar toggler functionality
    $("#navbar-toggler").on("click", function () {
      const isOpen = $(this).hasClass("open");
      $(this).toggleClass("open", !isOpen);
      $("#main-nav").toggleClass("show", !isOpen);
    });

    // Timer identifier for managing click events.
    $(document).ready(function () {
      $(".dropdown-toggle").on("click", function (e) {
        if (window.innerWidth <= 991) {
          e.preventDefault();
          const $this = $(this);

          if ($this.data("dropdown-shown")) {
            window.location.href = $this.attr("href");
          } else {
            $this.data("dropdown-shown", true);
            $this
              .parent()
              .addClass("show")
              .find(".dropdown-menu")
              .addClass("show");

            $(document).one("click", function (e) {
              if (!$(e.target).closest(".dropdown").length) {
                $(".dropdown-toggle").data("dropdown-shown", false);
                $(".dropdown, .dropdown-menu").removeClass("show");
              }
            });
          }
        }
      });

      $(".navbar-nav .dropdown-toggle").on("click", function (e) {
        if (window.innerWidth <= 991 && $(this).attr("href") !== "#") {
          if ($(this).parent().hasClass("show")) {
            window.location.href = $(this).attr("href");
          }
        }
      });
    });

    // Close navbar on clicking outside of it
    $(document).on("click", function (e) {
      if (!$(e.target).closest("#main-nav, .navbar-toggler").length) {
        $("#main-nav").removeClass("show");
        $(".navbar-toggler").removeClass("open");
      }
    });

    /*
     * Process block functionalities - Start
     */

    // Process block tabs functionality
    $(".process-block__tabs-button").on("click", function () {
      $(".process-block__tabs-button").removeClass("active");
      $(this).addClass("active");
    });

    // FIXED: Progress bar functionality with throttled scroll
    const processSteps = $(".process-block__step-progress-line");

    function isInViewport($element) {
      const windowHeight = $(window).height();
      const windowScrollTop = $(window).scrollTop();
      const elementOffset = $element.offset().top;

      return (
        elementOffset <= windowScrollTop + windowHeight &&
        elementOffset >= windowScrollTop
      );
    }

    function animateProgress() {
      processSteps.each(function () {
        const $step = $(this);

        if (!$step.data("animated") && isInViewport($step)) {
          const progress = $step.data("progress");
          $step.css("--target-progress", progress + "%");
          $step.addClass("animate");

          // Mobile fix: Ensure animation completes regardless of animation issues
          if (window.innerWidth <= 768) {
            setTimeout(function () {
              if ($step.width() < ($step.parent().width() * progress) / 100) {
                $step.css("width", progress + "%");
              }
            }, 1500);
          }

          $step.data("animated", true);
        }
      });
    }

    // FIXED: Throttled scroll and resize listeners
    const throttledAnimateProgress = throttle(animateProgress, 200);
    $(window).on("scroll.progressAnimation", throttledAnimateProgress);
    $(window).on(
      "resize.progressAnimation",
      debounce(function () {
        // Reset animation state on resize
        processSteps.data("animated", false);
        animateProgress();
      }, 250)
    );

    animateProgress(); // Initial check

    // FIXED: Scroll to top functionality with throttled scroll
    $(function () {
      if ($("body").hasClass("scroll-to-top")) {
        $("body").append(`
        <div class="progress-wrap" id="progress-scroll">
          <svg class="progress-circle" width="50" height="50" viewBox="0 0 100 100">
            <path d="M50,1 a49,49 0 1,1 0,98 a49,49 0 1,1 0,-98"></path>
          </svg>
          <img src="/wp-content/uploads/2025/02/chevron-up-outline-new.svg" alt="Scroll to Top" class="progress-arrow" />
        </div>
      `);

        const $btn = $("#progress-scroll"),
          $path = $btn.find("path"),
          $arrow = $btn.find(".progress-arrow"),
          pathLength = $path[0]?.getTotalLength();

        if (pathLength) {
          $path.css({
            strokeDasharray: `${pathLength} ${pathLength}`,
            strokeDashoffset: pathLength,
          });

          // FIXED: Throttled scroll handler
          const handleScrollProgress = throttle(function () {
            const scrollTop = $(window).scrollTop(),
              docHeight = $(document).height() - $(window).height(),
              progress = pathLength - (scrollTop * pathLength) / docHeight;

            $path.css("strokeDashoffset", progress);
            $btn.toggleClass("active", scrollTop > 50);

            const currentColor = $("[data-section-color]")
              .toArray()
              .reduce((color, section) => {
                const $sec = $(section),
                  secTop = $sec.offset().top,
                  secBottom = secTop + $sec.outerHeight();

                return scrollTop + window.innerHeight >= secTop &&
                  scrollTop + window.innerHeight <= secBottom
                  ? $sec.data("section-color")
                  : color;
              }, "light");

            $arrow.css(
              "filter",
              currentColor === "dark" ? "invert(1)" : "none"
            );
          }, 100);

          $(window).on("scroll", handleScrollProgress);

          $btn.on("click", () =>
            $("html, body").animate({ scrollTop: 0 }, 400)
          );
        }
      }
    });

    /*
     * Side Block Video Player
     */
    $(".side-block__play-button, .courses-block__play-button").on(
      "click",
      function () {
        const $button = $(this);
        const $wrapper = $button.closest(
          ".side-block__video-wrapper, .courses-block__video-wrapper"
        );
        const $video = $wrapper.find("video")[0];
        const $icon = $button.find(
          ".side-block__play-button-icon, .courses-block__play-button-icon"
        );

        if (!$video) return;

        // Pause all other videos first
        $(".side-block__video").each(function () {
          if (this !== $video && !this.paused) {
            this.pause();
            $(this)
              .closest(
                ".side-block__video-wrapper, .courses-block__video-wrapper"
              )
              .find(
                ".side-block__play-button-icon, .courses-block__play-button-icon"
              )
              .removeClass("is-playing");
          }
        });

        // Toggle play/pause for this video
        if ($video.paused) {
          $video.muted = false;
          const playPromise = $video.play();

          if (playPromise !== undefined) {
            playPromise
              .then(() => {
                $icon.addClass("is-playing");
              })
              .catch(() => {
                // Try muted if autoplay prevented
                $video.muted = true;
                $video
                  .play()
                  .then(() => {
                    $icon.addClass("is-playing");
                  })
                  .catch((err) => {
                    console.error("Video playback failed:", err);
                  });
              });
          } else {
            $icon.addClass("is-playing");
          }
        } else {
          $video.pause();
          $icon.removeClass("is-playing");
        }
      }
    );

    /*
     * FIXED: Video playback on scroll with optimized IntersectionObserver
     */
    function handleScrollVideos() {
      const videoContainers = document.querySelectorAll(
        ".content-block__media_wrapper, .side-block__video-wrapper, .courses-block__video-wrapper"
      );
      if (!videoContainers.length) return;

      // FIXED: Single observer with optimized settings
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target.querySelector("video");
            if (!video) return;

            if (entry.isIntersecting) {
              if (video.paused) {
                video.play().catch((e) => console.log("Video play error:", e));
              }
            } else {
              if (!video.paused) {
                video.pause();
              }
            }
          });
        },
        {
          threshold: 0.25,
          rootMargin: "50px 0px",
        }
      );

      // Only observe containers with videos
      videoContainers.forEach((container) => {
        const video = container.querySelector("video");
        if (video) {
          observer.observe(container);
        }
      });
    }

    handleScrollVideos();

    /*
     * FIXED: Rotating text functionality with cleanup
     */
    $(
      ".banner-block_title-rotating-text, .contact-block_title-rotating-text, .insights-block_title-rotating-text, .sunil-block_title-rotating-text, .courses-block__title-rotating-text"
    ).each(function () {
      const $container = $(this);
      const $items = $container.find(
        ".banner-block_title-rotating-text-item, .contact-block_title-rotating-text-item, .insights-block_title-rotating-text-item, .sunil-block_title-rotating-text-item, .courses-block__title-rotating-text-item"
      );

      if ($items.length <= 1) {
        $items.show();
        $container.css("width", $items.eq(0).outerWidth() + 20 + "px");
        return;
      }

      const maxWidth = Math.max(
        ...$items
          .map(function () {
            return $(this).outerWidth();
          })
          .get()
      );
      $container.css("width", maxWidth + 20 + "px");

      let forward = true;
      let index = 0;
      let interval;

      function rotateText() {
        $items.removeClass("slide-down slide-up").hide();
        const $currentItem = $items.eq(index);
        $currentItem.show().addClass(forward ? "slide-down" : "slide-up");

        if (forward) {
          index++;
          if (index >= $items.length) {
            forward = false;
            index--;
          }
        } else {
          index--;
          if (index < 0) {
            forward = true;
            index++;
          }
        }
      }

      rotateText();
      interval = setInterval(rotateText, 3000);

      $container.hover(
        function () {
          clearInterval(interval);
        },
        function () {
          interval = setInterval(rotateText, 3000);
        }
      );

      // FIXED: Cleanup on page unload
      $(window).on("beforeunload", function () {
        clearInterval(interval);
      });
    });

    /*
     * FIXED: Timeline block functionality with optimized intervals
     */
    setTimeout(() => {
      const $items = $(".timeline-block__item");
      const total = $items.length;
      if (!total) return; // FIXED: Exit early if no items

      let current = 0,
        animating = false;
      let isMobile = window.innerWidth < 768;

      $items.first().addClass("visible");

      const setLineHeights = () => {
        $items.each((i, item) => {
          if (i < total - 1) {
            const $current = $(item);
            const $next = $items.eq(i + 1);
            const $currentIcon = $current.find(".timeline-block__icon");
            const $nextIcon = $next.find(".timeline-block__icon");
            if (!$currentIcon.length || !$nextIcon.length) return;
            const distance = $nextIcon.offset().top - $currentIcon.offset().top;
            const height = Math.max(distance - (isMobile ? 20 : 36), 50);
            $current.find(".timeline-block__line").css("height", `${height}px`);
          }
        });
      };

      const isInViewport = ($el) => {
        const rect = $el[0].getBoundingClientRect();
        const threshold = isMobile ? 0.5 : 0.7;
        return (
          rect.top < window.innerHeight * threshold ||
          (rect.bottom >= 0 && rect.top <= window.innerHeight)
        );
      };

      const processStep = () => {
        if (current >= total - 1 || animating) return;
        const $currentItem = $items.eq(current);
        if (!isInViewport($currentItem)) return;

        animating = true;
        const $lineFill = $currentItem.find(".timeline-block__line-fill");
        if ($lineFill.length) $lineFill.css("height", "100%");

        setTimeout(
          () => {
            current++;
            if (current < total) $items.eq(current).addClass("visible");
            animating = false;
            processStep();
          },
          isMobile ? 800 : 1000
        );
      };

      setLineHeights();

      // FIXED: Throttled scroll handler
      const throttledProcessStep = throttle(processStep, 200);
      $(window).on("scroll", throttledProcessStep);

      processStep();

      // FIXED: Use requestAnimationFrame instead of setInterval
      let rafId;
      function checkTimeline() {
        if (!animating) processStep();
        rafId = requestAnimationFrame(checkTimeline);
      }
      rafId = requestAnimationFrame(checkTimeline);

      // FIXED: Debounced resize handler with cleanup
      const handleResize = debounce(() => {
        const wasMobile = isMobile;
        isMobile = window.innerWidth < 768;
        setLineHeights();
        if (wasMobile !== isMobile) {
          const visibleCount = $items.filter(".visible").length;
          current = Math.max(visibleCount - 1, 0);
        }
      }, 250);

      $(window).on("resize", handleResize);

      // FIXED: Cleanup
      $(window).on("beforeunload", function () {
        cancelAnimationFrame(rafId);
      });
    }, 300);

    /*
     * FIXED: Counter animation with optimized IntersectionObserver
     */
    const counters = $(
      ".sunil-block__counter-number, .banner-block__promo-card-number, .about-block__item-card-body-number, .side-block__counter-number"
    );

    if (counters.length) {
      const animateCounter = (container) => {
        const $container = $(container);
        const containerData = $container.attr("data-count");
        const spanData = $container.find("span[data-count]").attr("data-count");
        const dataCount = containerData || spanData;
        const goal = parseFloat(dataCount);

        if (isNaN(goal)) return;

        let $targetSpan;
        if (containerData) {
          $targetSpan = $container
            .find("span")
            .filter((i, el) => /-goal/.test($(el).attr("class") || ""))
            .first();
          if (!$targetSpan.length) {
            $targetSpan = $container.find("span").first();
          }
        } else {
          $targetSpan = $container.find("span[data-count]").first();
        }

        $targetSpan.text("0");
        $container.css("opacity", "1");

        const duration = 2000;
        let startTime = null;

        const updateCounter = (timestamp) => {
          if (!startTime) startTime = timestamp;
          const elapsed = timestamp - startTime;
          const progress = Math.min(elapsed / duration, 1);
          $targetSpan.text(Math.floor(progress * goal));

          if (progress < 1) {
            requestAnimationFrame(updateCounter);
          } else {
            $targetSpan.text(goal);
          }
        };

        requestAnimationFrame(updateCounter);
      };

      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              animateCounter(entry.target);
              obs.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.5 }
      );

      counters.each((_, el) => {
        observer.observe(el);
      });
    }

    /*
     * FIXED: Testimonial slider with performance optimizations
     */
    (function initTestimonialsModule() {
      const testimonialsBlock = document.querySelector(".testimonials-block");
      if (!testimonialsBlock) return;

      if (document.readyState === "complete") {
        init();
      } else {
        window.addEventListener("load", init);
      }

      function init() {
        setupVideoHandlers();

        if ("requestIdleCallback" in window) {
          requestIdleCallback(initTestimonials, { timeout: 2000 });
        } else {
          setTimeout(initTestimonials, 100);
        }
      }

      function initTestimonials() {
        if (typeof Swiper !== "undefined") {
          initSwiper();
        } else {
          loadSwiperResources();
        }

        const grid = document.querySelector(".testimonials-grid");
        if (grid && typeof $.fn.masonry === "function") {
          const $grid = $(grid);

          if (typeof $.fn.imagesLoaded === "function") {
            $grid.imagesLoaded().progress(function () {
              $grid.masonry({
                itemSelector: ".testimonial-item",
                percentPosition: true,
              });
            });
          } else {
            $grid.masonry({
              itemSelector: ".testimonial-item",
              percentPosition: true,
            });

            setTimeout(function () {
              $grid.masonry("layout");
            }, 500);
          }
        }
      }

      function loadSwiperResources() {
        // Check if already loaded
        if (document.querySelector('link[href*="swiper-bundle.min.css"]')) {
          if (typeof Swiper !== "undefined") {
            initSwiper();
          }
          return;
        }

        const linkStyle = document.createElement("link");
        linkStyle.rel = "stylesheet";
        linkStyle.href =
          "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
        document.head.appendChild(linkStyle);

        const script = document.createElement("script");
        script.src =
          "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
        script.defer = true;
        script.onload = initSwiper;
        document.body.appendChild(script);
      }

      function initSwiper() {
        const swiperContainer = document.querySelector(".testimonials-swiper");
        if (!swiperContainer) return;

        const slides = swiperContainer.querySelectorAll(".swiper-slide");
        slides.forEach((slide) => {
          slide.style.width = "";
        });

        new Swiper(".testimonials-swiper", {
          slidesPerView: 4,
          spaceBetween: 30,
          grabCursor: true,
          lazy: true, // FIXED: Enable lazy loading
          preloadImages: false,
          watchSlidesProgress: true,
          updateOnImagesReady: true,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".next-slide",
            prevEl: ".prev-slide",
          },
          breakpoints: {
            320: { slidesPerView: 1 },
            560: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            998: { slidesPerView: 4 },
          },
          on: {
            slideChange: pauseAllVideos,
          },
        });
      }

      function setupVideoHandlers() {
        // FIXED: Event delegation with single handler
        $(testimonialsBlock).on(
          "click",
          ".testimonials-block__play-button",
          function () {
            const $button = $(this);
            const $video = $button
              .closest(".testimonials-block__video-wrapper")
              .find("video")[0];
            const $icon = $button.find(".testimonials-block__play-button-icon");

            if (!$video) return;

            if ($video.paused) {
              pauseAllVideos();

              $video.muted = false;
              $video.setAttribute("playsinline", "");

              // FIXED: Set preload only when needed
              $video.setAttribute("preload", "metadata");

              const playPromise = $video.play();
              if (playPromise !== undefined) {
                playPromise
                  .then(() => {
                    $icon.addClass("is-playing");
                  })
                  .catch(() => {
                    $video.muted = true;
                    $video.play().then(() => {
                      $icon.addClass("is-playing");
                    });
                  });
              } else {
                $icon.addClass("is-playing");
              }
            } else {
              $video.pause();
              $icon.removeClass("is-playing");
            }
          }
        );

        // FIXED: Set preload="none" on all testimonial videos initially
        testimonialsBlock.querySelectorAll("video").forEach((video) => {
          video.preload = "none";
          video.setAttribute("playsinline", "");
        });
      }

      function pauseAllVideos() {
        testimonialsBlock.querySelectorAll("video").forEach((video) => {
          if (!video.paused) {
            video.pause();
            const wrapper = video.closest(".testimonials-block__video-wrapper");
            if (wrapper) {
              const icon = wrapper.querySelector(
                ".testimonials-block__play-button-icon"
              );
              if (icon) icon.classList.remove("is-playing");
            }
          }
        });
      }
    })();

    /*
     * FIXED: Slider block with performance optimizations
     */
    (function initSliderModule() {
      const sliderBlock = document.querySelector(".slider-block");
      if (!sliderBlock) return;

      if (document.readyState === "complete") {
        initSlider();
      } else {
        window.addEventListener("load", initSlider);
      }

      function initSlider() {
        if (typeof Swiper !== "undefined") {
          createSliderSwiper();
        } else {
          loadSwiperResources();
        }
      }

      function loadSwiperResources() {
        // Check if already loaded
        if (document.querySelector('link[href*="swiper-bundle.min.css"]')) {
          if (typeof Swiper !== "undefined") {
            createSliderSwiper();
          }
          return;
        }

        const linkStyle = document.createElement("link");
        linkStyle.rel = "stylesheet";
        linkStyle.href =
          "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
        document.head.appendChild(linkStyle);

        const script = document.createElement("script");
        script.src =
          "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
        script.defer = true;
        script.onload = createSliderSwiper;
        document.body.appendChild(script);
      }

      function createSliderSwiper() {
        const swiperContainer = document.querySelector(".slider-swiper");
        if (!swiperContainer) return;

        const slides = swiperContainer.querySelectorAll(".swiper-slide");
        slides.forEach((slide) => {
          slide.style.width = "";
        });

        new Swiper(".slider-swiper", {
          slidesPerView: 1,
          spaceBetween: 30,
          centeredSlides: true,
          grabCursor: true,
          loop: true,
          lazy: true, // FIXED: Enable lazy loading
          preloadImages: false,
          watchSlidesProgress: true,
          effect: "slide",
          navigation: {
            nextEl: ".slider-next",
            prevEl: ".slider-prev",
          },
          breakpoints: {
            576: { slidesPerView: 1 },
            768: { slidesPerView: 1 },
            992: { slidesPerView: 1 },
          },
        });
      }
    })();
  });
})(jQuery);
